import request from "@/utils/request";

export function login(data) {
    return request({
        url: '/login',
        method: 'post',
        data
    })
}

export function sendEmailCode(data) {
    return request({
        url: '/sendEmailCode',
        method: 'post',
        data
    })
}

export function emailLogin(data) {
    return request({
        url: '/emailLogin',
        method: 'post',
        data
    })
}

export function addUser(data) {
    return request({
        url: '/user/add',
        method: 'post',
        data
    })
}

export function editUser(data) {
    return request({
        url: '/user/edit',
        method: 'post',
        data
    })
}

export function getUserInfo() {
    return request({
        url: '/getInfo',
        method: 'get'
    })
}



